export const topCities = [
	{
		id: 1,
		title: "Lagos",
	},
	{
		id: 1,
		title: "London",
	},
	{
		id: 1,
		title: "Tokyo",
	},
	{
		id: 1,
		title: "Toronto",
	},
	{
		id: 1,
		title: "Paris",
	},
];
export const details = [
	{
		id: 1,
		title: "Lagos",
	},
	{
		id: 1,
		title: "London",
	},
	{
		id: 1,
		title: "Tokyo",
	},
	{
		id: 1,
		title: "Toronto",
	},
	{
		id: 1,
		title: "Paris",
	},
];
